/* eslint-disable */
import * as THREE from 'three';
window.THREE = THREE;

// import {
//   Scene,
//   Color,
//   WebGLRenderer,
//   PerspectiveCamera,
//   BufferGeometry,
//   Mesh,
//   MeshBasicMaterial,
//   Vector3,
//   AmbientLight,
//   Group,
//   vector2
// } from 'three';
// import {
//   OrbitControls
// } from '../../../../controls/OrbitControls';
// require('three/examples/js/controls/OrbitControls');
// require('../../../../controls/OrbitControls');
// require('./OrbitControls')
// import { OrbitControls } from 'three/examples/js/controls/OrbitControls.js';

class Label {

  constructor(container) {
    this.container = document.querySelector(container);

    this.containerWidth = this.container.clientWidth;
    this.containerHeight = this.container.clientHeight;
    // console.log(this.container.getBoundingClientRect());


    const rendererPar = {
      antialias: !0,
      alpha: !!0,
      precision: 'highp',
      //截图todataUrl需要设置为!0
      preserveDrawingBuffer: true,
      // logarithmicDepthBuffer: !0
    }
    this.scene = new THREE.Scene();
    this.camera = new THREE.PerspectiveCamera(30, this.containerWidth / this.containerHeight, .01,
      30);


    this.camera.position.set(0, 7.5, 0);
    // this.scene.this.camera.rotateX(-Math.PI / 2);
    // console.log(this.scene.this.camera.position)
    this.scene.add(this.camera);

    this.scene.add(new THREE.AmbientLight(0XFFFFFF, 1));
    // window.this.camera = this.scene.this.camera;



    this.controls = new OrbitControls(this.camera, this.container);
    // this.controls.target.y = -1;
    // window.controls = this.controls;
    this.controls.enableRotate = !!0;
    this.controls.enableKeys = !!0;
    this.controls.enableZoom = !0;
    this.controls.panSpeed = .6;
    this.controls.minDistance = .2;
    this.controls.maxDistance = 7.5;

    this.controls.mouseButtons = {
      LEFT: THREE.MOUSE.PAN,
      MIDDLE: THREE.MOUSE.DOLLY,
      RIGHT: THREE.MOUSE.ROTATE
    }
    this.controls.update();
    // console.log(this.controls.target)
    this.renderer = new THREE.WebGLRenderer(rendererPar);
    // console.log(window.devicePixelRatio);

    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setSize(this.containerWidth, this.containerHeight);
    this.renderer.setClearColor(0xFFFFFF, 1.0);


    this.container.appendChild(this.renderer.domElement);


    // console.log(this.scene.this.camera, this.controls)


    // this.pointGroup = new THREE.Group();
    // this.scene.add(this.pointGroup);
    this.lineGroup = new THREE.Group();
    this.lineGroup.name = "lineGroup";
    this.scene.add(this.lineGroup);

    this.raycaster = new THREE.Raycaster();
    this.raycaster.linePrecision = .01;
    this.mouse = new THREE.Vector2();
    this.stackModels = []; //存储加载的模块,存储栈

    //记录所有折点数据，形成二维数组
    this.allInflectionPoints = [];
    //存储鼠标选取坐标
    this.pos = new THREE.Vector3();
    this.posBool = !!0;
    //记录相机拖拽前初始位置
    this.mouseDownCameraPos = new THREE.Vector3();

    //selected
    this.selected = null;
    this.model = null;

    this.adsorbStep = 10;
    this.pointScale = .01;
    //移动过程中存储移动的线
    this.movingTmpLine = [];

    // this.breakLine = [];
    // this.breakNewLine = [];
    // this.breakLineIndex = [];

    this.pointId = 0;
    this.inflectionPoints = [];
    this.wheelVector = [];
    this.isMove = !!0;
    this.timer = null;


    // const render = () => {
    //   requestAnimationFrame(render);
    //   this.controls.update();
    //   this.renderer.render(this.scene, this.camera);

    //   // 通过摄像机和鼠标位置更新射线
    //   this.raycaster.setFromCamera(this.mouse, this.camera);
    //   if (!this.plane) return;
    //   // 计算物体和射线的焦点
    //   const intersects = this.raycaster.intersectObjects([this.plane], !!0);
    //   if (intersects.length > 0) {
    //     // intersects[0].object.scale.set(.12,.12,.12)
    //     // console.log(intersects);

    //     this.pos.copy(intersects[0].point);
    //     // this.pos.set(intersects[0].point.x, .01, intersects[0].point.z);
    //     this.posBool = !0;
    //     // intersects[0].object.name !== 'plane'?intersects[0].object.scale.multiplyScalar(1.1):null;
    //     // this.selected = intersects[0].object.name !== 'plane' ? intersects[0].object : null;
    //     // this.pos.y = .07;

    //   } else {
    //     this.pos.set(0, 0, 0);
    //     this.posBool = !!0;
    //     // this.pos.set(0, 0, 0);
    //   }



    // }

    this.render();

    this.container.addEventListener('mousedown', this.onMouseDown.bind(this), !!0);
    this.container.addEventListener('mousemove', this.onMouseMove.bind(this), !!0);
    this.container.addEventListener('mouseup', this.onMouseUp.bind(this), !!0);
    this.container.addEventListener('wheel', this.onWheel.bind(this), !!0);
    // this.container.addEventListener('resize',this.onWindowResize.bind(this), !!0)
    // this.container.addEventListener('keydown', this.onKeyDown.bind(this), !!0);
    // window.addEventListener('keydown', this.onKeyDown.bind(this), !!0);
    this.container.onkeydown = this.onKeyDown;


    this.spriteMaterial = new THREE.MeshBasicMaterial({
      color: 0xFF9A05,
      polygonOffset: !0,
      polygonOffsetFactor: -1,
      polygonOffsetUnits: -8,
    });
    this.selectPointMat = new THREE.MeshBasicMaterial({
      color: 0xD0021B,
      polygonOffset: !0,
      polygonOffsetFactor: -1,
      polygonOffsetUnits: -8,
    });
    this.addSprite();

    this.lineMaterial = new THREE.MeshBasicMaterial({
      color: 0x0602FF,
      // emissive: 0xF18930,
      transparent: !!0,
      polygonOffset: !0,
      polygonOffsetFactor: -1,
      polygonOffsetUnits: -6,
      side: THREE.DoubleSide

    });
    this.selectLineMat = new THREE.MeshBasicMaterial({
      color: 0xD0021B,
      // emissive: 0xF18930,
      transparent: !!0,
      polygonOffset: !0,
      polygonOffsetFactor: -1,
      polygonOffsetUnits: -6,
      side: THREE.DoubleSide

    });

    // this.lineMaterial = new THREE.LineBasicMaterial({
    //   color: 0x0602FF,
    //   transparent: !0,
    //   polygonOffset: !0,
    //   polygonOffsetFactor: -1.0,
    //   polygonOffsetUnits: -6.0
    // });
    // this.selectLineMat = new THREE.LineBasicMaterial({
    //   color: 0xD0021B,
    //   transparent: !0,
    //   polygonOffset: !0,
    //   polygonOffsetFactor: -1.0,
    //   polygonOffsetUnits: -6.0
    // });

  }

  render() {
    this.controls.update();
    this.renderer.render(this.scene, this.camera);



  }

  onWindowResize(h, w) {
    this.containerWidth = w;
    this.containerHeight = h;

    this.camera.aspect = this.containerWidth / this.containerHeight;
    this.camera.updateProjectionMatrix();

    this.renderer.setSize(this.containerWidth, this.containerHeight);
  }

  onKeyDown(e) {
    // e.preventDefault();
    if (!this.model) return;
    switch (e.keyCode) {
      case 37:
        this.model.position.x -= .01;
        this.moveSelectModel(this.model, this.model.position);
        break;
      case 38:
        this.model.position.z -= .01;
        this.moveSelectModel(this.model, this.model.position);
        break;
      case 39:
        this.model.position.x += .01;
        this.moveSelectModel(this.model, this.model.position);
        break;
      case 40:
        this.model.position.z += .01;
        this.moveSelectModel(this.model, this.model.position);
        break
      default:
        break;
    }

  }

  onWheel(e) {



    // console.log(this.ratios);


    const rangeX = this.camera.position.y * Math.tan(THREE.Math.degToRad(this.camera.fov / 2));
    const rangeZ = this.camera.position.y * Math.tan(THREE.Math.degToRad(this.camera.fov / 2)) /
      this.camera.aspect;
    // console.log(rangeX,this.camera.position.y);
    // console.log(Math.tan(THREE.Math.degToRad(this.camera.fov / 2) ));
    // const leftX = this.camera.position.x - offsetX - rangeX;
    // const leftZ = this.camera.position.z - offsetZ - rangeZ;
    // this.ratios[0] = (this.pos.x - leftX) / (rangeX * 2);
    // this.ratios[1] = (this.pos.z - leftZ) / (rangeZ * 2);
    const leftX = this.pos.x - this.ratios[0] * (rangeX * 2);
    const leftZ = this.pos.z - this.ratios[1] * (rangeZ * 2);
    const offsetX = this.camera.position.x - rangeX - leftX;
    const offsetZ = this.camera.position.z - rangeZ - leftZ;
    // console.log(offsetX, offsetZ);
    this.camera.position.x -= offsetX;
    this.controls.target.x = this.camera.position.x;
    this.camera.position.z -= offsetZ;
    this.controls.target.z = this.camera.position.z;
    // const offsetX =
    this.render();
  }
  onMouseDown(e) {

    e.preventDefault();

    if (!this.lineBool && !this.pointBool) this.mouseDown = !0;
    // this.mouseDownCameraPos.set(this.pos.x,this.camera.position.y,this.pos.z);
    this.mouseDownCameraPos.copy(this.camera.position);
    this.model = this.mouseDown && this.selected ? this.selected : null;

    this.model ? this.model.startPos = new THREE.Vector3().copy(this.model.position) : null;
    this.model && !this.model.handle ? this.model.handle = [] : null;
    //this.model.handle   move[起点，终点,index(栈内存中原来的位置　),removelines,addlines]
    //break [point,line1.line2,index(栈内存中原来的位置　),line1index,line2index]
    if (this.model) {
      // console.log(this.model.name);

      this.moveLines = [];
      this.setMat(this.model);
    } else {
      if (!this.tmpSelectPoint) return;
      this.tmpSelectPoint.material = this.tmpSelectPoint.name !== 'line' ? this.spriteMaterial :
        this.lineMaterial;
    }
    this.render();
  }
  setMat(model) {

    if (this.tmpSelectPoint) {
      if (this.tmpSelectPoint.name !== 'line') this.tmpSelectPoint.material = this.spriteMaterial;
      else this.tmpSelectPoint.material = this.lineMaterial;
    }
    if (model.name !== 'line') model.material = this.selectPointMat;
    else model.material = this.selectLineMat;

    this.tmpSelectPoint = model;

  }

  moveSelectModel(model, pos) {
    if (model.name === 'line') return;

    model.position.copy(pos);
    model.endPos = new THREE.Vector3().copy(pos);


    // this.movingCount = 0;


    this.lineGroup.children.forEach(v => {
      if (!this.isStartOrEnd(v, model.id)) return;


      // console.log(v.start, v.end, this.lineGroup.getObjectById(v.start), this.lineGroup.getObjectById(v.end));
      // this.moveLines.push(v);
      // console.log(this.moveLines);
      // this.movingCount++
      const line = v.start === model.id ? this.moveLine(model.id, v.end) :
        this.moveLine(v.start, model.id);
      // this.movingTmpLine.push(line) && console.log(v.start, v.end);

      this.movingTmpLine.forEach((v1, index) => {
        if (v1.start === line.start && v1.end === line.end) this.movingTmpLine.splice(
          index, 1)
      })
      this.movingTmpLine.push(line)
      this.removeModel(v);
    })
    // console.log(this.movingTmpLine);
    this.render();


  }

  onMouseMove(event) {



    this.render();
    event.preventDefault();
    this.mouse.x = (event.layerX / this.containerWidth) * 2 - 1;
    this.mouse.y = -(event.layerY / this.containerHeight) * 2 + 1;

    // console.log(event.layerX,event.layerY,event.clientX,event.clientY);

    this.controls.enablePan = this.model && this.mouseDown ? !!0 : !0;
    !this.controls.enablePan && this.moveSelectModel(this
      .model, this.pos);

    // if (!this.controls.enablePan) {
    //   this.isMove = true;
    //   if (this.timer) clearTimeout(this.timer);
    //   // console.log(this.isMove); // 移动时
    //   const that = this;
    //   this.timer = setTimeout(function () {
    //     this.isMove = false;
    //     that.spliceLine();
    //     this.movingTmpLine = [];
    //     this.moveLines = [];
    //     // console.log(this.isMove); // 静止后
    //   }, 10);
    //   this.isMove ? this.moveSelectModel(this
    //     .model, this.pos) : null;

    // }

    // 通过摄像机和鼠标位置更新射线
    this.raycaster.setFromCamera(this.mouse, this.camera);
    if (!this.plane) return;
    // 计算物体和射线的焦点
    const intersectsPos = this.raycaster.intersectObjects([this.plane], !!0);
    if (intersectsPos.length > 0) {
      // intersects[0].object.scale.set(.12,.12,.12)
      // console.log(intersects);

      this.pos.copy(intersectsPos[0].point);
      this.posBool = !0;

    } else {
      this.pos.set(0, 0, 0);
      this.posBool = !!0;
      // this.pos.set(0, 0, 0);
    }


    const rangeX = this.camera.position.y * Math.tan(THREE.Math.degToRad(this.camera.fov / 2));
    const rangeZ = this.camera.position.y * Math.tan(THREE.Math.degToRad(this.camera.fov / 2)) /
      this.camera.aspect;
    // console.log(rangeX,this.camera.position.y);
    // console.log(Math.tan(THREE.Math.degToRad(this.camera.fov / 2) ));
    const leftX = this.camera.position.x - rangeX;
    const leftZ = this.camera.position.z - rangeZ;

    const ratioX = (this.pos.x - leftX) / (rangeX * 2);
    const ratioZ = (this.pos.z - leftZ) / (rangeZ * 2);
    this.ratios = [ratioX, ratioZ];
    const intersects = this.raycaster.intersectObjects(this.lineGroup.children, !!0);
    // console.log(this.lineGroup.children.filter(v => v.name === 'line'));
    // this.lineGroup.children.filter(v => v.name === 'line')[0].raycast(this.raycaster,intersects)
    // console.log(intersects);

    // const intersects = this.raycaster.intersectObjects(this.lineGroup.children, !!0);
    if (intersects.length > 0) {

      // console.log(intersects);
      this.container.style.cursor = 'pointer';

      // this.selected = intersects[0].object;
      //当点和线重叠时，选择点
      if (intersects.length > 1) {
        intersects.forEach(v => {

          if (v.object.name !== 'line') this.selected = v.object;

        })
      } else this.selected = intersects[0].object;

      if (!this.adsorbPoint) return !!0;
      this.adsorbPoint.visible = !0;
      // console.log(this.selected);

      this.selected && this.selected.name !== 'line' ? this.adsorbPoint.position.copy(this
        .selected.position) : this.adsorbPoint.position.copy(intersects[0].point);
      // this.selected.material.color = new THREE.Color(0XFF0000);


      // if (this.selected != intersects[0].object) {
      //     // if (this.selected) this.selected.material.opacity = .7;
      //     this.selected = intersects[0].object;
      //     // this.selected.material.color = new THREE.Color(0,0,0);

      // }
    } else {
      // if (this.selected) this.selected.material.color = new THREE.Color(0X0000FF);
      this.container.style.cursor = 'default';
      this.selected = null;
      if (!this.adsorbPoint) return !!0;
      this.adsorbPoint.visible = !!0;
    }
    this.render();

  }


  change(arr, k, j) {
    var c = arr[k];

    arr[k] = arr[j];
    arr[j] = c;
  }

  onMouseUp(e) {
    e.preventDefault();
    this.mouseDown = !!0;
    if (e.which === 3) return;

    if (this.mouseDownCameraPos.distanceTo(this.camera.position) > .003) return;
    this.mouseDownCameraPos = new THREE.Vector3();
    this.pointBool ? this.addPoint() : null;
    this.lineBool ? this.addInflectionPoint() : null;

    // console.log(this.movingCount);

    //当点移动时
    // this.model && this.model.name === 'point' && this.model.handle.push({
    //     'move': [this.model.startPos, new THREE.Vector3().copy(this.pos)]
    // }) && this.model.handle[this.model.handle.length - 1].move.push(this.stackModels.indexOf(this.model)) && this.change(this.stackModels, this.stackModels.indexOf(this.model), this.stackModels.length - 1);
    // console.log(this.isStartOrEnd(this.model));
    if (this.model && this.model.name === 'point') {


      this.model.handle.push({
        'move': [this.model.startPos, new THREE.Vector3().copy(this.pos)]
      });


      this.model.handle[this.model.handle.length - 1].move.push(this.stackModels.indexOf(this
        .model));
      if (this.stackModels.includes(this.model)) {
        this.change(this.stackModels, this.stackModels.indexOf(this.model), this.stackModels
          .length - 1);
      } else {
        this.createStack(this.model);
      }

    }


    // 当存在线的移动时
    // console.log(this.model.name);

    // console.log(this.model.name,this.model.handle);

    if (this.movingTmpLine.length <= 0) return;

    // // console.log(this.moveLines);

    // this.moveLines.forEach(v => {
    //   const line = v.start === this.model.id ? this.moveLine(this.model.id, v.end) :
    //     this.moveLine(v.start, this.model.id);
    //   // this.movingTmpLine.push(line) && console.log(v.start, v.end);

    //   // this.movingTmpLine.forEach((v1, index) => {
    //   //   if (v1.start === line.start && v1.end === line.end) this.movingTmpLine.splice(
    //   //     index, 1)
    //   // })
    //   this.movingTmpLine.push(line)
    // })

    const removelines = [];
    const addlines = [];
    // this.createStack(this.model);
    this.model.handle.push({
      'move': [this.model.startPos, new THREE.Vector3().copy(this.pos)]
    });

    this.model.handle[this.model.handle.length - 1].move.push(this.stackModels.indexOf(this
      .model));

    if (this.stackModels.includes(this.model)) {

      this.change(this.stackModels, this.stackModels.indexOf(this.model), this.stackModels
        .length - 1);
    } else {

      this.createStack(this.model);
      // const lines = this.lineGroup.children.filter(v => (v.start === this.model.id || v.end ===
      //   this.model.id));
      // // console.log(lines);
      // lines.forEach(line => {
      //   this.createStack(line);
      // })


      // this.model.handle[this.model.handle.length - 1].move.push(this.stackModels.indexOf(this
      //   .model));
    }
    //替换栈存储中应该被替换的线
    // console.log(this.model.handle);

    // console.log(this.movingTmpLine);

    for (let i = this.movingTmpLine.length - 1; i >= 0; i--) {
      // console.log(this.movingTmpLine[this.movingTmpLine.length - i - 1]);
      //
      this.stackModels.forEach((v1, index) => {
        // console.log(v1,this.movingTmpLine[i]);

        if (v1 &&
          v1.start === this.movingTmpLine[i].start &&
          v1.end === this.movingTmpLine[i].end) {

          removelines.push(v1);
          addlines.push(this.movingTmpLine[i]);


          this.model.handle[this.model.handle.length - 1].move.push(removelines, addlines);
          this.stackModels.splice(index, 1, this.movingTmpLine[i]);
          // console.log(this.model.handle);
        }

      })
    }


    // console.log(this.model.handle);

    this.movingTmpLine = [];
    // this.moveLines = [];
    // this.movingCount = 0;
    this.render();
  }

  spliceLine() {
    if (!this.model || !this.moveLines || this.moveLines.length <= 0) return;

    // console.log(this.moveLines);

    this.moveLines.forEach(v => {
      const line = v.start === this.model.id ? this.moveLine(this.model.id, v.end) :
        this.moveLine(v.start, this.model.id);
      // this.movingTmpLine.push(line) && console.log(v.start, v.end);

      // this.movingTmpLine.forEach((v1, index) => {
      //   if (v1.start === line.start && v1.end === line.end) this.movingTmpLine.splice(
      //     index, 1)
      // })
      this.movingTmpLine.push(line)
    })

    // const removelines = [];
    // const addlines = [];
    // // this.createStack(this.model);
    // this.model.handle.push({
    //   'move': [this.model.startPos, new THREE.Vector3().copy(this.pos)]
    // });

    // this.model.handle[this.model.handle.length - 1].move.push(this.stackModels.indexOf(this
    //   .model));

    // if (this.stackModels.includes(this.model)) {

    //   this.change(this.stackModels, this.stackModels.indexOf(this.model), this.stackModels
    //     .length - 1);
    // } else {

    //   this.createStack(this.model);
    //   // const lines = this.lineGroup.children.filter(v => (v.start === this.model.id || v.end ===
    //   //   this.model.id));
    //   // // console.log(lines);
    //   // lines.forEach(line => {
    //   //   this.createStack(line);
    //   // })


    //   // this.model.handle[this.model.handle.length - 1].move.push(this.stackModels.indexOf(this
    //   //   .model));
    // }
    // //替换栈存储中应该被替换的线


    // // console.log(this.movingTmpLine,this.stackModels);

    // for (let i = this.movingTmpLine.length - 1; i >= 0; i--) {
    //   // console.log(this.movingTmpLine[this.movingTmpLine.length - i - 1]);
    //   //
    //   this.stackModels.forEach((v1, index) => {
    //     // console.log(v1,this.movingTmpLine[i]);

    //     if (v1 &&
    //       v1.start === this.movingTmpLine[i].start &&
    //       v1.end === this.movingTmpLine[i].end) {

    //       removelines.push(v1);
    //       addlines.push(this.movingTmpLine[i]);


    //       this.model.handle[this.model.handle.length - 1].move.push(removelines, addlines);
    //       this.stackModels.splice(index, 1, this.movingTmpLine[i]);
    //       // console.log(this.model.handle);
    //     }

    //   })
    // }



    // this.movingTmpLine = [];
    // this.moveLines = [];
  }


  // *******
  initModel(img) {
    if (!img) return;
    const texture = new THREE.TextureLoader().load(img);
    // console.log(img);

    setTimeout(() => {
      this.textureHeight = texture.image.height;
      this.textureWidth = texture.image.width;

      this.textureWidth >= this.textureHeight ? (this.mapWidth = 4) &&
        (this.mapHeight = 4 / this.textureWidth * this.textureHeight) : (this.mapHeight =
          4) &&
        (this.mapHeight = 4 / this.mapHeight * this.textureWidth);

      // console.log(this.mapWidth, this.mapHeight);

      //平面默认宽为4，高为 4 * 宽 / 高
      const geometry = new THREE.PlaneBufferGeometry(this.mapWidth, this.mapHeight);

      const material = new THREE.MeshPhongMaterial({
        color: 0xffffff,
        side: THREE.FrontSide,
        map: texture
      });


      this.plane = new THREE.Mesh(geometry, material);
      this.plane.name = 'plane';
      this.plane.rotateX(-Math.PI / 2);
      this.scene.add(this.plane);

      this.render();
    }, 2000)

  }

  initPanoPoint(arr) {
    // console.log(arr);

    arr.forEach(v => {
      const model = this.pointSprite.clone();
      model.pointId = this.pointId;
      this.pointId++;
      model.name = 'point';

      model.iconUrl = this.iconUrl;
      model.pointName = this.pointName;
      model.pointType = this.pointType;
      model.position.x = (v[0] / this.textureWidth) * this.mapWidth - this.mapWidth / 2;
      model.position.z = (v[1] / this.textureHeight) * this.mapHeight - this.mapHeight /
        2;
      model.position.y = 0;
      this.lineGroup.add(model);
      // console.log(this.lineGroup);

      this.createStack(model);
      this.stackIndex++;
    })
  }

  getResolution(img, callback) {
    if (!img) return;
    //获取图片分辨率
    //可用setinterval轮询，有值再callback

    const texture = new THREE.TextureLoader().load(img);

    setTimeout(() => {
      // console.log(texture.image);

      callback(texture.image.width, texture.image.height);
    }, 2000)
  };

  addSprite() {

    //点标注母体
    // this.pointSprite = new THREE.Sprite(this.spriteMaterial);
    // this.pointSprite.scale.set(this.pointScale, this.pointScale, this.pointScale);

    var geometry = new THREE.CircleBufferGeometry(this.pointScale, 32);


    this.pointSprite = new THREE.Mesh(geometry, this.spriteMaterial);
    this.pointSprite.rotateX(-Math.PI / 2);
    // this.pointGroup.add(this.sprite);
  }

  addPoint() {
    // console.log(this.pos.z);

    // const point = this.sprite.clone();
    if (!this.posBool) return;

    // const point = new THREE.Sprite().copy(this.pointSprite);
    // console.log(1);


    if (this.model && this.model.name !== 'line' && this.adsorbPoint && this.adsorbPoint
      .visible) {
      //点没有吸附功能
      // this.inflectionPoints.push(this.model.id);
      return;

    } else {
      const point = this.pointSprite.clone();
      point.pointId = this.pointId;
      this.pointId++;
      point.name = 'point';
      this.adsorbPoint && this.adsorbPoint.visible ? point.position.copy(this.adsorbPoint
        .position) : point.position.copy(this.pos);

      // this.pointGroup.add(point);
      // console.log(this.stackModels);
      point.iconUrl = this.iconUrl;
      point.pointName = this.pointName;
      point.pointType = this.pointType;
      this.lineGroup.add(point);


      if (this.model && this.model.name === 'line' && this.adsorbPoint && this.adsorbPoint
        .visible) {

        //将point改为inflectionPoint
        point.name = "inflectionPoint";

        // this.stackModels.splice(this.stackModels.indexOf(this.model), 1, point);
        this.addBreakPoint(this.model, point, 1);

      } else this.createStack(point);
      // this.inflectionPoints.push(point.id);



    }

    // const point = this.pointSprite.clone();
    // point.name = 'point';
    // this.adsorbPoint && this.adsorbPoint.visible ? point.position.copy(this.adsorbPoint.position) : point.position.copy(this.pos);

    // this.pointGroup.add(point);
    // this.createStack(point);

    // console.log(point, this.pos);

  }

  addLine() {
    this.inflectionPoints = [];
  }

  finishAddLine() {
    //结束绘制本条线，并将顶点添加到折点数组中
    this.inflectionPoints.length > 0 ? this.allInflectionPoints.push(this.inflectionPoints) :
      null;
    // console.log(this.allInflectionPoints);

  }


  //断点生成的新线

  addBreakLine(selectModel, point, num) {
    const nums = num ? num : 0;

    const line1 = this.moveLine(selectModel.start, point.id);
    // line1.breakBefore = selectModel;
    line1.start = selectModel.start;
    line1.end = point.id;
    const line2 = this.moveLine(point.id, selectModel.end);
    line2.start = point.id;
    line2.end = selectModel.end;
    // line2.breakBefore = selectModel;


    point.handle = selectModel.handle;
    point.handle.push({
      'break': [selectModel, line1, line2, this.stackModels.indexOf(selectModel), nums]
    });

    if (this.stackModels.includes(selectModel)) {
      // this.stackModels.splice(this.stackModels.indexOf(selectModel), 1, line1);
      // this.change(this.stackModels, this.stackModels.indexOf(line1), this.stackModels.length - 1);
      this.stackModels.splice(this.stackModels.indexOf(selectModel), 1);


    } else {
      // this.createStack(line1);
    }
    this.createStack(line1);
    this.createStack(line2);
    this.createStack(point);
    this.removeModel(selectModel);




  }

  //添加断点,打断一条线
  addBreakPoint(selectModel, point, num) {


    // console.log(selectModel.start, selectModel.end);

    let modelIndex;


    if (this.inflectionPoints.includes(selectModel.start) && this.inflectionPoints.includes(
        selectModel.end)) {
      //取索引较小的

      modelIndex = this.inflectionPoints.indexOf(selectModel.start) < this.inflectionPoints
        .indexOf(selectModel.end) ?
        this.inflectionPoints.indexOf(selectModel.start) : this.inflectionPoints.indexOf(
          selectModel.end);

      this.inflectionPoints.splice(modelIndex, 0, point.id);
      this.addBreakLine(selectModel, point, num);
    } else {
      this.allInflectionPoints.forEach((v, index) => {
        if (v.includes(selectModel.start) && v.includes(selectModel.end)) {
          //取索引较小的

          modelIndex = v.indexOf(selectModel.start) < v.indexOf(selectModel.end) ? v.indexOf(
            selectModel.start) : v.indexOf(selectModel.end);

          v.splice(modelIndex, 0, point.id);
          this.addBreakLine(selectModel, point, num);

        }
      })
    }
    // console.log(this.stackModels);

  }

  addInflectionPoint() {
    if (!this.posBool) return;


    if (this.model && this.model.name !== 'line' && this.adsorbPoint && this.adsorbPoint
      .visible) {

      //吸附的时候将原来的点改成折点
      this.model.name = 'inflectionPoint';
      this.inflectionPoints.push(this.model.id);
      if (this.inflectionPoints.length > 1) {
        this.drawLine(this.inflectionPoints[this.inflectionPoints.length - 2], this
          .inflectionPoints[this.inflectionPoints.length - 1], !0);
        // const len = this.inflectionPoints.length;
      }
      // this.createStack(this.model);

    } else {

      const point = this.pointSprite.clone();
      point.name = "inflectionPoint";
      point.pointId = this.pointId;
      this.pointId++;
      point.pointName = this.pointName;
      point.iconUrl = this.iconUrl;
      point.pointType = this.pointType;
      this.adsorbPoint && this.adsorbPoint.visible ? point.position.copy(this.adsorbPoint
        .position) : point.position.copy(this.pos);

      this.lineGroup.add(point);

      this.inflectionPoints.push(point.id);
      if (this.inflectionPoints.length > 1) {
        this.drawLine(this.inflectionPoints[this.inflectionPoints.length - 2], this
          .inflectionPoints[this.inflectionPoints.length - 1]);

        // const len = this.inflectionPoints.length;
      }

      if (this.model && this.model.name === 'line') {

        // this.stackModels.splice(this.stackModels.indexOf(this.model), 1, point);
        this.addBreakPoint(this.model, point);
        // this.createStack(point);

      } else this.createStack(point);



      // console.log(this.stackModels);


    }


    // this.inflectionPoints.length > 1 ? this.drawLine(this.inflectionPoints) : null;

    // this.drawLine(this.inflectionPoints)
  }


  moveLine(id1, id2) {




    const geometry = new THREE.BufferGeometry();
    // const point = [];


    const position1 = this.lineGroup.getObjectById(id1).position;
    const position2 = this.lineGroup.getObjectById(id2).position;

    // if (position2.z >= position1.z) {
    let distance = Math.sqrt(Math.pow((position2.z - position1.z), 2) + Math.pow((position2
      .x -
      position1.x), 2));
    // distance = position2.z >= position1.z ? distance : -distance;
    const sinData = (position2.z - position1.z) / distance;
    const cosData = Math.sqrt(1 - Math.pow(sinData, 2));
    // console.log(Math.asin(sinData) / Math.PI * 180, Math.acos(cosData) / Math.PI * 180);
    let offsetX = .002 * sinData;
    let offsetY = .002 * cosData;
    // console.log(sinData,cosData);


    const verArr = [];


    if (position2.x >= position1.x) {
      verArr.push(position1.x - offsetX, 0, position1.z + offsetY, //0
        position1.x + offsetX, 0, position1.z - offsetY, //1
        position2.x + offsetX, 0, position2.z - offsetY, //2
        position2.x - offsetX, 0, position2.z + offsetY //3
      )
    } else {
      verArr.push(position1.x + offsetX, 0, position1.z + offsetY, //0
        position1.x - offsetX, 0, position1.z - offsetY, //1
        position2.x - offsetX, 0, position2.z - offsetY, //2
        position2.x + offsetX, 0, position2.z + offsetY //3
      )
    }

    // console.log(2*offsetX);
    const vertices = new Float32Array(verArr);
    const indices = [0, 1, 2, 2, 3, 0];



    geometry.addAttribute('position', new THREE.Float32BufferAttribute(vertices, 3))
    geometry.setIndex(indices);
    const uvs = [0, 0, 1, 0, 1, 1, 0, 1];
    geometry.addAttribute('uv', new THREE.BufferAttribute(new Float32Array(uvs), 2));


    const line = new THREE.Mesh(geometry, this.lineMaterial);
    line.name = 'line';
    line.start = id1;
    line.end = id2;




    this.lineGroup.add(line);

    return line;

    // } else {



    //   let distance = Math.sqrt(Math.pow((position1.z - position2.z), 2) + Math.pow((position1
    //     .x -
    //     position2.x), 2));
    //   // distance = position2.z >= position1.z ? distance : -distance;
    //   const sinData = (position1.z - position2.z) / distance;
    //   const cosData = Math.sqrt(1 - Math.pow(sinData, 2));
    //   // console.log(Math.asin(sinData) / Math.PI * 180, Math.acos(cosData) / Math.PI * 180);
    //   let offsetX = .002 * sinData;
    //   let offsetY = .002 * cosData;
    //   // console.log(sinData,cosData);


    //   const verArr = [];



    //   verArr.push(position2.x - offsetX, 0, position2.z + offsetY, //0
    //     position2.x + offsetX, 0, position2.z - offsetY, //1
    //     position1.x + offsetX, 0, position1.z - offsetY, //2
    //     position1.x - offsetX, 0, position1.z + offsetY //3
    //   )
    //   // console.log(2*offsetX);
    //   const vertices = new Float32Array(verArr);
    //   const indices = [0, 1, 2, 2, 3, 0];



    //   geometry.addAttribute('position', new THREE.Float32BufferAttribute(vertices, 3))
    //   geometry.setIndex(indices);
    //   const uvs = [0, 0, 1, 0, 1, 1, 0, 1];
    //   geometry.addAttribute('uv', new THREE.BufferAttribute(new Float32Array(uvs), 2));


    //   const line = new THREE.Mesh(geometry, this.lineMaterial);
    //   line.name = 'line';
    //   line.start = id2;
    //   line.end = id1;




    //   this.lineGroup.add(line);

    //   return line;
    // }

    // const geometry = new THREE.BufferGeometry();
    // const point = [];


    // const position1 = this.lineGroup.getObjectById(id1).position;
    // const position2 = this.lineGroup.getObjectById(id2).position;

    // point.push(position1.x, position1.y, position1.z, position2.x, position2.y, position2.z);

    // geometry.addAttribute('position', new THREE.Float32BufferAttribute(point, 3))

    // const line = new THREE.Line(geometry, this.lineMaterial);
    // line.name = 'line';
    // line.start = id1;
    // line.end = id2;
    // // console.log(line);


    // this.lineGroup.add(line);
    // return line;

  }

  //drawing line
  drawLine(id1, id2, adsorbBool) {

    const line = this.moveLine(id1, id2);
    line.adsorbBool = adsorbBool;
    this.createStack(line);

  }

  deleteInflectionPoint(model) {
    let modelIndex;
    let arrIndex;
    // console.log(this.allInflectionPoints[0].length);

    this.allInflectionPoints.forEach((v, index) => {
      if (v.includes(model.id)) {
        arrIndex = index;
        modelIndex = v.indexOf(model.id);

      }
    })

    // console.log(arrIndex,modelIndex);


    this.allInflectionPoints[arrIndex].splice(modelIndex, 1);

    this.lineIndexOfStack = [];
    let len = this.lineGroup.children.length;
    let count = 0;
    // modelClone.removelines = [];
    //删除的线
    model.removelines = [];
    //折点在折点数组中的索引记录下来
    model.inflectionPointIndex = [arrIndex, modelIndex];
    for (let i = len - 1; i >= 0; i--) {

      if (this.isStartOrEnd(this.lineGroup.children[i], model.id)) {
        // console.log(model,this.lineGroup[i]);

        // if (modelClone) {
        //     this.lineClone(modelClone, `removeLine${count}`, this.lineGroup.children[i], model.id, modelClone.id);
        //     //当栈存储达到最大，因为下面会删除第一个元素，因此index-1
        //     if (this.stackModels.includes(this.lineGroup.children[i])) this.stackModels.length >= this.adsorbStep ? this.lineIndexOfStack.push(this.stackModels.indexOf(this.lineGroup.children[i]) - 1) :
        //         this.lineIndexOfStack.push(this.stackModels.indexOf(this.lineGroup.children[i]));
        //     count++;
        //     modelClone.removeLineLength = count;
        // }

        // modelClone.removelines.push(this.lineGroup.children[i], this.stackModels.indexOf(this.lineGroup.children[i]));
        // this.stackModels.splice(this.stackModels.indexOf(this.lineGroup.children[i]), 1)
        // this.removeModel(this.lineGroup.children[i]);
        model.removelines.push(this.lineGroup.children[i], this.stackModels.indexOf(this.lineGroup
          .children[i]));
        this.stackModels.splice(this.stackModels.indexOf(this.lineGroup.children[i]), 1)
        this.removeModel(this.lineGroup.children[i]);

      }
    }
  }

  deleteModel() {

    if (!this.model) return;

    this.model.del = !0;


    // const modelClone = this.model.clone();


    // // console.log(this.model,this.model.parent,this.lineGroup);

    // modelClone.del = !0;
    // modelClone.parent = this.model.parent;
    // //当栈存储达到最大，因为下面会删除第一个元素，因此index-1
    // modelClone.index = this.stackModels.length >= this.adsorbStep ? this.stackModels.indexOf(this.model) - 1 : this.stackModels.indexOf(this.model);

    // console.log(this.stackModels, this.model, modelClone.index);

    // modelClone.handle = this.model.handle ? this.model.handle : null;
    // modelClone.start = this.model.start;
    // modelClone.end = this.model.end;

    if (this.model.name === "inflectionPoint") {
      this.deleteInflectionPoint(this.model);

      // console.log(this.lineIndexOfStack, this.stackModels, modelClone);

    } else if (this.model.name === "line") {
      // const lines = this.lineGroup.children.filter(v => v.start === this.model.id || v.end ===
      //   this.model.id);
      // // console.log(lines);
      // this.model.name = lines.length === 0 ? 'point' : 'inflectionPoint';

      const linesStart = this.lineGroup.children.filter(v => v.start === this.model.start || v
        .end === this.model.start);
      const linesEnd = this.lineGroup.children.filter(v => v.start === this.model.end || v.end ===
        this.model.end);
      //  console.log(points);
      linesStart.length === 1 ? this.lineGroup.getObjectById(this.model.start).name = "point" :
        null;
      linesEnd.length === 1 ? this.lineGroup.getObjectById(this.model.end).name = "point" : null;
      //  this.lineGroup.getObjectById(this.model.start).name = "point"
      //  this.lineGroup.getObjectById(this.model.end).name = "point"
    }
    // console.log(modelClone);

    // this.createStack(modelClone);
    this.createStack(this.model);
    this.removeModel(this.model);

    this.model = null;
    this.render();
    if (!this.tmpSelectPoint) return;
    this.tmpSelectPoint.material = this.tmpSelectPoint.name !== 'line' ? this.spriteMaterial :
      this.lineMaterial;
    this.render();
  }

  isLine(index, group) {
    return group.children[index].isLine;
  }

  isStartOrEnd(item, modelId) {
    return item && (item.start === modelId ||
      item.end === modelId)

  }

  isOnlyStartOrEnd(item, modelId) {
    // console.log(modelId, item.start, item.end);

    return item && ((item.start === modelId &&
      item.end !== modelId) || (item.start !== modelId &&
      item.end === modelId))
  }

  //改变cloneLine的start || end

  lineClone(model, pro, line, thisModelId, modelId) {
    model[pro] = line.clone();
    model[pro].start = line.start === thisModelId ? modelId : line.start;
    model[pro].end = line.end === thisModelId ? modelId : line.end;
  }


  removeModel(mesh) {

    mesh.geometry && mesh.geometry.dispose();
    mesh.material && mesh.material.dispose();
    mesh.parent && mesh.parent.remove(mesh);
    this.render();
  }

  //存储栈
  createStack(item) {
    this.stackModels.push(item);

    if (this.stackModels.length > this.adsorbStep) {
      // this.stackModels.shift();

      // const deleteItem = this.stackModels.shift();
      // this.removeModel(deleteItem);
    }

  }



  //撤销操作
  backOut() {
    this.render();
    // console.log(this.stackModels.length, this.stackIndex);
    const arr = this.stackModels;

    const point = arr[arr.length - 1];
    if (point && point.del) {
      //恢复删除点位
      this.lineGroup.add(point);
      this.recoveryItem(point);
      this.stackModels.pop();
      this.render();
      // this.stackIndex--;
      return;
    }

    // console.log(this.stackModels[this.stackModels.length - 1].handle);

    if (this.stackModels.length <= this.stackIndex && (!this.stackModels[this.stackModels.length -
        1].handle || this.stackModels[this.stackModels.length -
        1].handle.length < 1)) return;



    // console.log('stackModels', this.stackModels);



    if (point.name === 'point' && point.handle && point.handle.length > 0 && Object.keys(point
        .handle[point.handle.length - 1])[0] === 'move') {
      //点move
      const handleArrs = this.stackModels[this.stackModels.length - 1].handle;
      const handleArr = handleArrs.pop().move;

      // console.log(handleArr[handleArr.length - 1].move)
      point.position.copy(handleArr[0]);

      //替换索引
      handleArr[2] >= 0 ?
        this.change(this.stackModels, this.stackModels.length - 1, handleArr[2]) :
        this.stackModels.pop();
      this.render();
      return;
      // arr.splice(arr.length-1,1);
    } else if (point.name === 'inflectionPoint' && point.handle && point.handle.length > 0 &&
      Object.keys(point.handle[point.handle.length - 1])[0] === 'break') {
      //dian break
      const handleArrs = this.stackModels[this.stackModels.length - 1].handle;
      const handleArr = handleArrs.pop().break;
      // this.stackModels[this.stackModels.length - 1].handle;
      // console.log(handleArr[handleArr.length - 1].break);
      this.removeModel(handleArr[1]);
      this.removeModel(handleArr[2]);
      this.removeModel(point);
      // console.log(this.stackModels.length);

      this.stackModels.pop();
      // this.stackIndex--;
      this.stackModels.pop();
      // this.stackIndex--;
      this.stackModels.pop();
      // console.log(this.stackModels.length);
      // this.stackIndex--;
      this.lineGroup.add(handleArr[0]);
      handleArr[3] >= 0 ?
        this.stackModels.splice(handleArr[3], 0, handleArr[0]) : null;

      handleArr[4] ? this.backOutRemove(point, 1) : this.backOutRemove(point, 0);
      this.render();
      return;
      // arr.splice(arr.length-1,1);
    } else if (point.name === 'inflectionPoint' && point.handle && point.handle.length > 0 &&
      Object.keys(point.handle[point.handle.length - 1])[0] === 'move') {
      //折点移动
      const handleArrs = this.stackModels[this.stackModels.length - 1].handle;
      const handleArr = handleArrs.pop().move;
      point.position.copy(handleArr[0]);

      handleArr[3].forEach(v => {
        // console.log(v);

        this.lineGroup.add(v);
        this.stackModels.forEach((v1, index) => {
          if (v1.start === v.start &&
            v1.end === v.end) {
            // this.removeModel(v1);
            this.stackModels.splice(index, 1, v);
            // console.log(this.stackModels);

          }

        })

        handleArr[4].forEach(v => {
          // console.log(v);
          this.removeModel(v);
        });
      })

      //替换索引
      handleArr[2] >= 0 ?
        this.change(this.stackModels, this.stackModels.length - 1, handleArr[2]) :
        this.stackModels.pop();
      // this.stackIndex--;
      // handleArr.pop();
      this.render();
      return;

    }


    const item = this.stackModels.pop();
    // this.stackIndex--;
    // console.log(item);


    if (item.name === 'inflectionPoint') {
      //画线过程中撤销画线
      this.inflectionPoints.pop();

      // let count = 0;
      // while (count < item.removeLineLength) {
      //     const addLine = item[`removeLine${count}`];
      //     addLine.parent = this.lineGroup;
      //     this.lineGroup.add(addLine);
      //     count++;
      // }
    }

    this.backOutRemove(item);
    this.render();

  }

  //复原item
  recoveryItem(item) {
    // console.log(item);

    item.del = !!0;

    // item.index > -1 ? this.stackModels.splice(item.index, 1, item) : null;
    // this.inflectionPoints.push();

    if (item.name === 'inflectionPoint') {
      for (let i = 0; i < item.removelines.length; i += 2) {
        // console.log(item.removelines);

        this.lineGroup.add(item.removelines[i]);
        this.stackModels.splice(item.removelines[i + 1], 0, item.removelines[i])
      }

      // console.log(item.inflectionPointIndex);
      // console.log(this.allInflectionPoints[item.inflectionPointIndex[0]].length);

      this.allInflectionPoints[item.inflectionPointIndex[0]].splice(item.inflectionPointIndex[
        1], 0, item.id)
      // console.log(this.allInflectionPoints[item.inflectionPointIndex[0]].length);
    } else if (item.name === 'line') {
      // console.log(item);
      this.lineGroup.getObjectById(item.start).name = 'inflectionPoint';
      this.lineGroup.getObjectById(item.end).name = 'inflectionPoint';

    }

    this.render();
    // if (item.name === 'inflectionPoint') {
    //     let count = this.lineIndexOfStack.length - 1;
    //     while (count >= 0) {
    //         //清除索引小于0的值
    //         if (this.lineIndexOfStack[count] < 0) return;
    //         // this.lineGroup.add(item[`removeLine${count}`].clone());
    //         this.stackModels.splice(this.lineIndexOfStack[count], 1, item[`removeLine${count}`]);
    //         count--;
    //     }
    // }



    // console.log('delete', item, this.stackModels);
  }
  //删除item
  backOutRemove(item, num) {
    // console.log(item,this.stackModels);

    // console.log(item);


    if (item.name !== 'line') {
      //点归位和删除
      // const line = this.stackModels.length > 1 && this.stackModels[this.stackModels.length - 1].name === 'line' ? this.stackModels[this.stackModels.length - 1] : null;
      // if (!line) return;
      // if (line.end === item.id || line.start === item.id) {
      //     this.removeModel(line);
      //     this.stackModels.pop()
      // }

      if (item.name === 'inflectionPoint' && !num) {


        this.lineGroup.children.forEach(v => {
          if (v.end === item.id) {
            this.removeModel(v);
            this.stackModels.includes(v) ? this.stackModels.splice(this.stackModels.indexOf(
              v), 1) : null;
          }
        })
      }
      this.removeModel(item);


    } else {

      const point = !item.adsorbBool && this.lineGroup.getObjectById(item.end) ? this.lineGroup
        .getObjectById(item.end) : null;



      this.inflectionPointslength > 0 && this.inflectionPoints.splice(this.inflectionPoints
        .length - 1, 1);
      // new 9.9
      // this.stackModels.pop();

      // point ? this.stackModels.pop() && this.stackIndex-- && this.removeModel(point) : null;
      point ? this.stackModels.pop() && this.removeModel(point) : null;
      this.removeModel(item);
    }
    this.render();
  }
  //吸附
  adsorb() {

    this.adsorbPoint = this.pointSprite.clone();
    this.adsorbPoint.visible = !!0;
    this.scene.add(this.adsorbPoint);
    this.render();
  }

  //递归删除模型
  clearModels(models) {
    if (models.children.length === 0) return;
    const model = models.children[models.children.length - 1];
    model.geometry && model.geometry.dispose();
    model.material && model.material.dispose();
    models.remove(models.children.pop());

    return this.clearModels(models);
  }

  clearArr(arr) {
    arr.splice(0, arr.length);
  }

  clear() {
    // this.clearModels(this.plane);
    this.clearModels(this.lineGroup);
    // this.clearModels(this.scene);
    // this.clearArr(this.stackModels);
    this.allInflectionPoints = [];
    this.pointId = 0;
    this.stackModels = [];
    this.scene.remove(this.plane);
    this.render();
    // this.plane.geometry.dispose();
    // this.plane.material.dispose();

  }

  setProp(label, model) {
    if (!model) return;
    label.index = model.pointId;
    label.label_name = model.pointName;
    label.label_icon = model.iconUrl;
    label.label_category = model.pointType;
    label.label_code = '';
    const x = this.textureWidth * (model.position.x + this.mapWidth / 2) / this.mapWidth;
    const y = this.textureHeight * (model.position.z + this.mapHeight / 2) / this.mapHeight;

    label.coord.push(x);
    label.coord.push(y);
    return label;
  }

  exportData() {
    if (this.lineGroup.length === 0) return {};
    const point = [];
    const line = [];

    // this.mapWidth
    // this.mapHeight
    this.lineGroup.children.forEach(v => {

      if (v.name === 'point') {
        let label = {};
        label.coord = [];
        // point.index = v.id;

        point.push(this.setProp(label, v));
      }
    })
    // console.log(point);


    this.allInflectionPoints.forEach(v1 => {
      const lineArr = [];
      v1.forEach(v2 => {
        let label = {};
        label.coord = [];
        lineArr.push(this.setProp(label, this.lineGroup.getObjectById(v2)));
      })
      line.push(lineArr);
    })
    // console.log(line);

    const label_data = {
      'point': point,
      "line": line
    }

    // console.log(label_data);initPanoPoint

    return label_data;
  }


  getProp(label, model) {
    if (!label) return;

    model.pointId = label.index;
    model.pointName = label.label_name;
    model.iconUrl = label.label_icon;
    model.pointType = label.label_category;
    // label.label_code = '';

    model.position.x = (label.coord[0] / this.textureWidth) * this.mapWidth - this.mapWidth / 2;
    model.position.z = (label.coord[1] / this.textureHeight) * this.mapHeight - this.mapHeight /
      2;
    model.position.y = 0;
    this.pointId = (label.index && (label.index > this.pointId)) ? label.index + 1 : this.pointId;
    // console.log(label.index, this.pointId);

  }

  importData(data) {
    // console.log(data);


    if (!data) return;
    this.stackIndex = 0;
    //导入数据时，图片要传绝对地址
    // console.log(data);

    // this.clear();
    data.point.forEach(v => {
      const point = this.pointSprite.clone();

      this.getProp(v, point)
      // console.log(point);
      point.name = "point";
      this.lineGroup.add(point);
      this.createStack(point);
      this.stackIndex++;
    })
    data.line.forEach(v1 => {
      // console.log(v1);
      const arr = [];
      v1.forEach(v2 => {

        const point = this.pointSprite.clone();
        this.getProp(v2, point)
        point.name = "inflectionPoint";

        // console.log(point);

        // console.log(point.pointId);
        const repeatId = this.repeatPoint(point.pointId);
        // console.log(repeatId);

        if (repeatId.length > 0) {
          repeatId.forEach(v => {
            arr.push(v);
            if (arr.length > 1) {
              this.drawLine(v, arr[arr.length - 2]);
              this.stackIndex++;
            }
          })

        } else {
          arr.push(point.id);
          this.lineGroup.add(point);
          this.createStack(point);
          this.stackIndex++;
          if (arr.length > 1) {
            this.drawLine(arr[arr.length - 2], arr[arr.length - 1]);
            this.stackIndex++;
          }
        }

      })
      this.allInflectionPoints.push(arr);
      // this.lineGroup.add()
    })
    this.render();

  }

  repeatPoint(id) {
    let tmp = [];
    this.lineGroup.children.forEach(v => {

      if (v.pointId && (v.pointId === id)) {

        tmp.push(v.id);
      }
    })
    return tmp;
  }

}

export default Label;
